import { Info } from "lucide-react";

interface InfoTooltipProps {
  text: string;
  placement?: "top" | "bottom" | "left" | "right";
  size?: "sm" | "md" | "lg";
}

const InfoTooltip = ({ text, size = "sm" }: InfoTooltipProps) => {
  const iconSize = {
    sm: 14,
    md: 16,
    lg: 18,
  };

  return (
    <div className="relative group inline-flex cursor-help ml-2">
      <Info
        size={iconSize[size]}
        className="text-gray-500 hover:text-gray-700 transition-colors"
      />
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-gray-700 text-white text-sm rounded-md max-w-[300px] text-center opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50 pointer-events-none">
        {text}
        <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-700" />
      </div>
    </div>
  );
};

export default InfoTooltip;
